import { createReducer } from '@reduxjs/toolkit';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import actions from './actions';

interface InstallDependentAppState {
  readonly currentPage: number;
  readonly files: appStorageRecords.AppStorageFile[];
  readonly hasDataFetched: boolean;
  readonly isLoading: boolean;
  readonly searchQuery: string;
  readonly totalItems: number;
}

const initialState: InstallDependentAppState = {
  currentPage: 1,
  files: [],
  hasDataFetched: false,
  isLoading: false,
  searchQuery: '',
  totalItems: 0,
};

const installDependentAppReducer = createReducer(initialState, (builder) => {
  // fetchAppStorageFiles
  builder.addCase(actions.fetchAppStorageFiles.pending, (draft, { meta }) => {
    draft.isLoading = true;
    draft.searchQuery = meta.arg?.searchQuery ?? draft.searchQuery;
  });

  builder.addCase(actions.fetchAppStorageFiles.fulfilled, (draft, { payload }) => {
    draft.currentPage = payload.page;
    draft.files = payload.items;
    draft.hasDataFetched = true;
    draft.isLoading = false;
    draft.totalItems = payload.total_items;
  });

  builder.addCase(actions.fetchAppStorageFiles.rejected, (draft) => {
    draft.hasDataFetched = true;
    draft.isLoading = false;
  });

  builder.addCase(actions.reset, () => initialState);
});

export default installDependentAppReducer;
export {
  initialState,
  InstallDependentAppState,
};
